var _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCartSuccess = function SvgCartSuccess(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "inherit",
    height: "inherit",
    fill: "none",
    viewBox: "0 0 80 80"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#CED3D8",
    fillRule: "evenodd",
    d: "M21.646 25.407h3.988l1.083 4.114q.013.05.029.097l2.766 13.843q.01.113.034.223l1.2 6v.009a3.57 3.57 0 0 0 3.5 2.857h17.4a2.143 2.143 0 0 0 0-4.286H34.83l-.714-3.572h19.989c.1 0 .386.01.648-.034a2.89 2.89 0 0 0 2.16-1.683c.155-.354.232-.803.258-.951l.008-.04 2.26-11.034.006-.029a2.86 2.86 0 0 0-2.8-3.371h-26.02l-.952-3.643a3.57 3.57 0 0 0-3.485-2.786h-4.543a2.143 2.143 0 0 0 0 4.286",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#808A93",
    fillRule: "evenodd",
    d: "M38.446 57.693a3.283 3.283 0 1 0-6.566 0 3.283 3.283 0 0 0 6.563 0zm14.285 0a3.283 3.283 0 0 0-6.565 0 3.283 3.283 0 0 0 6.563 0z",
    clipRule: "evenodd"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cart-success_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#10B981",
    d: "M45.124 19.121h10.249s5.124 0 5.124 5.124v10.249s0 5.124-5.124 5.124H45.124S40 39.618 40 34.494V24.245s0-5.124 5.124-5.124"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M55.206 25.217a1.1 1.1 0 0 1 .171 1.545l-5.856 7.32a1.1 1.1 0 0 1-1.517.192l-2.928-2.196a1.099 1.099 0 0 1 1.318-1.757l2.077 1.558 5.189-6.489a1.1 1.1 0 0 1 1.546-.173",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "cart-success_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M40 19.121h20.497v20.497H40z"
  })))));
};
export default SvgCartSuccess;